import { render, staticRenderFns } from "./locate-table-model.vue?vue&type=template&id=cc54fa56&scoped=true"
import script from "./locate-table-model.vue?vue&type=script&lang=js"
export * from "./locate-table-model.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc54fa56",
  null
  
)

export default component.exports